<template>
<main class="container-1-1">
        <div class="container-header">
            <Breadcrumb
                v-bind:links="routesBread"
            >
            </Breadcrumb>
            <h2>Nuevo documento</h2>
        </div>
        <div class="container-body">
            <label for="filename">Nombre</label>
            <input id="filename" v-model="doc.filename" type="text"
            name="nombre" :class="{'error' : errors.has('nombre') }" v-validate="'required'"
            :placeholder="[[errors.has('nombre') ? errors.first('nombre') : 'Ingresa el nombre']]"/>

            <label for="description">Descripción</label>
            <input id="description" v-model="doc.description" type="text"
            name="descripción" :class="{'error' : errors.has('descripción') }" v-validate="'required'"
            :placeholder="[[errors.has('descripción') ? errors.first('descripción') : 'Ingresa una descripción']]"/>

            <label for="order">Orden</label>
            <input id="order" v-model="doc.order" type="number" min="0" step="1"
                name="orden" :class="{'error' : errors.has('orden')}" v-validate="'required'"
            :placeholder="[[errors.has('orden') ? errors.first('orden') : 'Ingresa una ubicación en la lista de Ayuda (orden)']]"/>

            <label for="file">Archivo</label>
            <input
                id="file"
                ref="fileInput"
                type="file"
                accept=".pdf,.mp4"
                @change="onFileSelected"
            />
            <div class="container-action-left" style="justify-content: start;">
                <button class="btn btn-secondary" v-on:click="onClickGoBack()">Volver</button>
                <button class="btn btn-secondary" v-on:click="onClickGoNext()">Subir Documento</button>
            </div>
        <!--mensaje de error-->
                <div v-if="errors.any() || validationMessage" class="validation-summary">
                    <div v-if="validationMessage" class="validation-summary__message"
                    >
                        {{ validationMessage }}
                    </div>

                    <div
                        v-for="error in errors.items" :key="error.id" class="validation-summary__error"
                    >
                        {{ error.msg }}
                    </div>
                </div>
    </div>

</main>
</template>
<script>
// @ is an alias to /src
import Breadcrumb from '@/components/Breadcrumb.vue'

import {restDocument} from '@/components/mixin/restDocument.js'

export default{
    name: 'DocumentsNew',
    mixins: [restDocument],
    data(){
        return{
            validationMessage: ''
        }
    },
    components:{
        Breadcrumb
    },
    computed:{
        routesBread: function() {
            return [
                {name: 'Documentos', path:'/documentos'},
                {name: 'Nuevo Documento'}
            ]
        }
    },
    props: [],
    methods: {
        onClickGoBack: function() {
            window.history.length > 1
            ? this.$router.go(-1)
            : this.$router.push('/documentos/')
        },

        onClickGoNext: function() {

            var that = this;
            this.$validator.validateAll().then(valid => {
                //actualizado manejo de error (mostrar mensaje a usuario) segun observacion SENAPRED 06/2026
                //("3. Al  crear un usuario con un correo existente, no se crea pero, no arroja ningún mensaje que indique el por qué.")
                if (!valid) {
                    this.validationMessage = 
                    'Hay errores en el formulario.';
                    return;
                }

                if (!this.doc.file){
                    this.validationMessage = 
                    'Debe seleccionar un archivo.';
                    return;
                }
                this.postDoc();
            })
                .catch(error =>{
                    this.validationMessage = 'Ocurrió un error inesperado';
                })
        },

        onFileSelected(event) {

            const file = event.target.files[0]

            if (!file) {
                return
            }

            const extension =
                file.name
                    .split('.')
                    .pop()
                    .toLowerCase()

            if (!this.allowedExtensions.includes(extension)) {

                this.validationMessage =
                    'Solo se permiten archivos PDF o MP4.'

                this.removeFile()

                return
            }

            if (file.size > this.maxFileSize) {

                this.validationMessage =
                    'El archivo no puede superar los 128 MB.'

                this.removeFile()

                return
            }

            this.validationMessage = ''

            this.doc.file = file
        },

        removeFile() {

            this.doc.file = null

            this.$refs.fileInput.value = ''

        }
    },
    created () {
        this.$store.getters.getPermissions.documents ? true : this.$router.push('/pagina-no-encontrada')
    }
}
</script>
<style lang="scss" scoped>
.validation-summary {
    margin-top: 1rem;
    padding: 1rem;
    border: 1px solid #dc3545;
    border-radius: 4px;
    background-color: #fff5f5;
}

.validation-summary__message {
    color: #dc3545;
    font-weight: 600;
    margin-bottom: 0.75rem;
}

.validation-summary__error {
    color: #dc3545;
    line-height: 1.5;
}

.validation-summary__error:not(:last-child) {
    margin-bottom: 0.25rem;
}
</style>
